import React from "react";
import { Box, Grid, Typography } from "@mui/material";

import ImageLoader from "../components/ImageLoader";

const ServiceDetail = ({ data }) => {
  return (
    <Grid container p={5}>
      <Grid size={styles.grid15} />
      <Grid size={styles.grid9} sx={styles.container}>
        <Box sx={styles.circle(data.circleColor || data.color)} />
        <Grid container alignItems="center">
          <Grid item size={styles.grid7}>
            <Box sx={styles.leftColumn}>
              <Typography sx={styles.tag(data?.color)}>{data.tag}</Typography>
              <Typography sx={styles.title}>{data.title}</Typography>
              <Box sx={styles.line(data?.color)} />
              {data.paragraphs?.map((paragraph, index) => (
                <Typography key={index} sx={styles.paragraph}>
                  {paragraph}
                </Typography>
              ))}
              {data.highlight && (
                <Box sx={styles.highlight(data.color, data.bgColor)}>
                  <Typography sx={styles.highlightText}>
                    {data.highlight}
                  </Typography>
                </Box>
              )}
              {data.footer && (
                <Typography sx={styles.footer}>{data.footer}</Typography>
              )}
            </Box>
          </Grid>
          <Grid item size={styles.grid5}>
            <Box sx={styles.imageContainer}>
              <ImageLoader
                src={data.image}
                alt={data.title}
                width="100%"
                height="100%"
                borderRadius={2}
                style={styles.objet}
              />
            </Box>
          </Grid>
        </Grid>
      </Grid>
      <Grid size={styles.grid15} />
    </Grid>
  );
};

export default ServiceDetail;

const styles = {
  container: {
    position: "relative",
    backgroundColor: "#FFFFFF",
    borderRadius: "20px",
    overflow: "hidden",
    boxShadow: "0px 18px 45px rgba(0,0,0,.08)",
    px: {
      xs: 3,
      sm: 5,
      md: 2,
      lg: 3,
    },
    py: {
      xs: 4,
      md: 2,
    },
    margin: "auto",
  },
  circle: (color) => ({
    position: "absolute",
    width: 180,
    height: 180,
    background: color,
    borderRadius: "50%",
    top: -90,
    left: -90,
    zIndex: 0,
  }),
  leftColumn: {
    position: "relative",
    zIndex: 5,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    height: "100%",
  },
  tag: (color) => ({
    color: color,
    fontWeight: 700,
    letterSpacing: "2px",
    textTransform: "uppercase",
    fontSize: {
      xs: 13,
      md: 10,
    },
    mb: 1,
  }),
  title: {
    color: "#11284A",
    fontWeight: 800,
    lineHeight: 1,
    fontSize: {
      xs: 42,
      sm: 52,
      md: 30,
      lg: 25,
    },
    mb: 2,
  },
  line: (color) => ({
    width: 72,
    height: 6,
    borderRadius: 50,
    background: color,
    mb: 2,
  }),
  paragraph: {
    color: "#244E77",
    fontWeight: 400,
    fontSize: {
      xs: 18,
      md: 15,
    },
    lineHeight: 1.5,
    mb: 1,
  },
  footer: {
    color: "#17335B",
    fontWeight: 700,
    fontSize: {
      xs: 21,
      md: 15,
    },
    lineHeight: 1.6,
    mt: 2,
  },
  highlight: (color, bgColor) => ({
    background: bgColor,
    borderLeft: `5px solid ${color}`,
    borderRadius: "0px 10px 10px 0px",
    p: 1,
    mr: 1,
    boxShadow: "0 10px 20px rgba(0,0,0,.03)",
  }),
  highlightText: {
    color: "#244E77",
    fontSize: {
      xs: 18,
      md: 13,
    },
    lineHeight: 1.7,
  },
  imageContainer: {
    width: "100%",
    height: {
      xs: 180,
      sm: 300,
      md: 300,
      lg: 400,
    },
    borderRadius: "12px",
    overflow: "hidden",
    justifyContent: "center",
    alignItems: "center",
  },
  image: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: "10px",
  },
  objet: {
    objectFit: "cover",
  },
  grid15: { xs: 12, sm: 1.5, md: 1.5, lg: 1.5 },
  grid9: { xs: 12, sm: 9, md: 9, lg: 9 },
  grid7: { xs: 12, sm: 7, md: 7, lg: 7 },
  grid5: { xs: 12, sm: 5, md: 5, lg: 5 },
};
